import { render, staticRenderFns } from "./rejectDialog.vue?vue&type=template&id=f70f4fac&scoped=true&"
import script from "./rejectDialog.vue?vue&type=script&lang=js&"
export * from "./rejectDialog.vue?vue&type=script&lang=js&"
import style0 from "./rejectDialog.vue?vue&type=style&index=0&id=f70f4fac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f70f4fac",
  null
  
)

export default component.exports